<template>
  <a-card :bordered="false">
    <div class="operation-wrap">
      <a-form-model label-width="120px">
        <a-row :gutter="20">
          <a-col :span="3">
            <a-form-model-item label="日期" :colon="false">
              <a-range-picker
                style="width: 100%"
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['Start Time', 'End Time']"
                v-model="searchForm.data.timeScope"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item label="运输单号" :colon="false">

              <a-input v-model="sendOrder" auto-complete="off" placeholder="请输入运输单号" clearable
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item label="IFS单号" :colon="false">
              <a-input v-model="ifs" auto-complete="off" placeholder="请输入IFS单号" clearable
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <a-form-model-item label="预警状态" prop="" :colon="false">
              <a-select v-model="isWarn" placeholder="请输入预警状态" clearable>
                <a-select-option
                  v-for="item in warnList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <a-form-model-item label="订单状态" prop="" :colon="false">
              <a-select v-model="orderStatus" placeholder="请输入订单状态" clearable>
                <a-select-option
                  v-for="item in orderStatusList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <a-form-model-item label="运输方式" :colon="false">
              <a-select v-model="express" filterable :collapse-tags="true"
                        placeholder="请输入运输方式" :clearable="true">
                <a-select-option
                  v-for="item in expressTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

          </a-col>
          <a-col :span="2">
            <a-form-model-item label="发货地点" :colon="false">
              <a-select v-model="sendCity" filterable multiple :collapse-tags="true"
                        placeholder="请输入发货地" :clearable="true">
                <a-select-option
                  v-for="item in cities"
                  :key="item.city"
                  :label="item.city"
                  :value="item.city">
                  {{ item.city }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="3">
            <a-form-model-item label="客户名称" :colon="false">
              <a-input v-model="customer" auto-complete="off" placeholder="请输入客户名称" clearable
              ></a-input>
            </a-form-model-item>

          </a-col>

          <a-col :span="3" align="center">
            <a-form-model-item label=" " :colon="false">
              <a-space>
                <a-button type="primary" icon="el-icon-search" @click="search">搜索</a-button>
                <a-dropdown-button v-has="'ORDER_IMPORT'">
                  导入运费和计费重量
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a-upload
                        style="margin-right: 20px"
                        action="/api/biz-order/import"
                        @change="handleSuccess"
                        :before-upload="beforeAvatarUpload"
                        :showUploadList=false>
                        上传文件
                      </a-upload>
                    </a-menu-item>
                    <a-menu-item icon="el-icon-download" @click="downloadExcel">下载模板
                    </a-menu-item>
                    <a-menu-item icon="el-icon-download" @click="downloadRecentExcel">按照条件导出订单
                    </a-menu-item>
                  </a-menu>
                </a-dropdown-button>
              </a-space>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div class="main-panel">
      <div class="main-content-wrap">
        <a-row>
          <a-col :span="24" class="table-style">
            <a-table
              row-key="id"
              :loading="form.loading"
              :data-source="table.data"
              :default-sort="table.sort"
              :pagination="table.pagination"
              @change="handleTableChange"
              ref="table.dataRef">
              <a-table-column
                :sorter="true"
                key="orderNo"
                data-index="orderNo" title="运输单号" width="120"
              >
              </a-table-column>
              <a-table-column
                :sorter="true"
                key="createAt"
                data-index="createAt" title="创建时间" width="85"
              >
                <template slot-scope="text, record">
                  <date-time-formatter :date-time="record.createAt"
                                       formatter="YYYY-MM-DD"></date-time-formatter>
                </template>
              </a-table-column>
              <a-table-column
                :sorter="true"
                key="deliveryAt"
                data-index="deliveryAt" title="发货时间" width="85"
              >
                <template slot-scope="text, record">
                  <date-time-formatter :date-time="record.deliveryAt"
                                       formatter="YYYY-MM-DD"></date-time-formatter>
                </template>
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="ifsNo" title="IFS No." width="70">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="wmsNo" title="WMS No." width="90">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="gpsNo" title="GPS No." width="130">
              </a-table-column>
                <a-table-column
                        data-index="salesCompany" title="Sales Company." width="130">
                </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="expressCode" title="运输方式" width="120">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="receiveAt" title="签收日期" width="95">
                <template slot-scope="text, record">
                  <a-tooltip :content="record.receiveAt">
                    <date-time-formatter :date-time="record.receiveAt"
                                         formatter="YYYY-MM-DD"></date-time-formatter>
                  </a-tooltip>
                </template>
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="sendCity" title="发货城市" width="80">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="receiveCity" title="收货城市" width="80">
              </a-table-column>
              <a-table-column data-index="customerName" title="客户名称" width=""
                              :show-overflow-tooltip='true'>
                <template slot-scope="text, record">
                  <a-tooltip :content="record.receiveAddress">
                    <div slot>{{ record.customerName }}</div>
                  </a-tooltip>
                </template>
              </a-table-column>
              <a-table-column data-index="orderStatusStr" title="订单状态" width="80">
              </a-table-column>
<!--              <a-table-column data-index="freight" title="运费" width="70">-->
<!--                <template slot-scope="text, record">-->
<!--                  {{ record.freight }}<span v-if="record.freight">元</span>-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--              <a-table-column data-index="chargeableWeight" title="计费重量" width="70">-->
<!--                <template slot-scope="text, record">-->
<!--                  {{ record.chargeableWeight }}<span v-if="record.chargeableWeight">kg</span>-->
<!--                </template>-->
<!--              </a-table-column>-->
<!--              <a-table-column data-index="aging" title="时效" width="70">-->
<!--                <template slot-scope="text, record">-->
<!--                  {{ record.agingStr }}<span v-if="record.agingStr">小时</span>-->
<!--                </template>-->
<!--              </a-table-column>-->

              <a-table-column
                :sorter="true"
                data-index="apiFreight" title="运费" width="90">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="totalShippingCost" title="运费总额" width="90">
              </a-table-column>

              <a-table-column
                :sorter="true"
                data-index="length" title="长/体积" width="90">
              </a-table-column>

              <a-table-column
                :sorter="true"
                data-index="width" title="宽" width="90">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="height" title="高" width="90">
              </a-table-column>
              <a-table-column
                :sorter="true"
                data-index="weight" title="重量" width="90">
              </a-table-column>

              <a-table-column data-index="documentMaker" title="制单人" width="100px">
              </a-table-column>
              <a-table-column fixed="right" title="操作" align="center">
                <template slot-scope="text, record">
                  <a-button type="link" @click="handledbClick(record)">查看轨迹
                  </a-button>
                  <a-divider type="vertical"/>
                  <a-button
                    :disabled="record.orderStatus === 'SEND'||record.orderStatus === 'CLOSED'"
                    type="link" @click="collectGoods(record)">揽收
                  </a-button>
                  <a-divider type="vertical"/>
                  <a-button type="link" @click="editBizOrder(record.id)" v-has="'ORDER_EDIT'">编辑
                  </a-button>
                  <a-divider v-if="record.transportType === 'GPS'" type="vertical"/>
                  <a-button
                    v-if="record.orderStatus === 'CLOSED'&&record.transportType === 'GPS'"
                    type="link" size="small"
                    @click="receipt(record)"
                    class="operationBtn">签收凭证
                  </a-button>
                  <a-button
                    v-if="record.orderStatus !== 'CLOSED'&&record.transportType === 'GPS'"
                    type="link" size="small" @click="sign(record.id)"
                    v-has="'ORDER_EDIT'" class="operationBtn">未签收
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </a-col>
        </a-row>
        <div style="height:800px;overflow: auto;background-color: #fff">
          <gaode-map v-if="gaoDeShow" :order-id="form.data.orderId"
                     :order="form.order"
                     style="height:98%;margin:5px"></gaode-map>
          <!--          <gaode-map v-if="gaoDeShow" :order-id="form.data.orderId"-->
          <!--                     :order="form.order"-->
          <!--                     style="height:98%;margin:5px"></gaode-map>-->
          <!--          <gaode-map v-if="gaoDeShow" :order-id="form.data.orderId"-->
          <!--                     :order="form.order"-->
          <!--                     style="height:98%;margin:5px"></gaode-map>-->
          <time-line v-if="timeLineShow" :order-id="form.data.orderId"
                     :express-code="form.data.expressCode"
                     :wms-no="form.data.wmsNo"
                     :ifs-no="form.data.ifsNo"
                     :receive-address="form.data.receiveAddress"
                     @fatherMethod="showTrace"
                     style="height:98%;margin:5px"></time-line>
        </div>
      </div>
    </div>
    <a-modal v-model="visible" width="600px">
      <order-salesman :order-id="form.data.orderId" :on-cancel-handler="onFormCancel"
                      :on-save-handler="onFormSave"></order-salesman>
    </a-modal>
    <a-modal v-model="imageVisible" width="20%" :footer="false">
      <a-empty
        :image="'api/'+ form.data.img"
        :image-style="{height: '600px'}"
        :description="false">
        <!--        <div slot="placeholder" class="image-slot">-->
        <!--          加载中<span class="dot">...</span>-->
        <!--        </div>-->
      </a-empty>
      <!--      <a-image :src="'api/'+form.data.img">-->
      <!--        <div slot="placeholder" class="image-slot">-->
      <!--          加载中<span class="dot">...</span>-->
      <!--        </div>-->
      <!--      </a-image>-->
      <div style="height: 50px">
        <a-button type="primary" @click="downloadImage('api/'+ form.data.img ,'凭证'+form.data.img)"
                  style="margin-top: 20px"
                  class="project-dialog-button">下载凭证
        </a-button>
      </div>
    </a-modal>
    <a-modal
      title="编辑订单"
      v-model="form.visible" :destroy-on-close="true" @cancel="onFormCancelEdit" @ok="onFormSaveEdit">
      <biz-order-edit
        :get-list="getList"
        ref="orderEdit"
        :biz-order-id="form.data.id">
      </biz-order-edit>
    </a-modal>
    <a-modal
      :title="dialogTitle"
      v-model="dialogVisible"
      :before-close="handleClose"
      width="30%"
      :close-on-click-modal="false">
      <!--      <a-form-model ref="form" label-width="120px">-->
      <!--        <a-form-model-item label="签收凭证">-->
      <a-upload
        ref="uploadRef"
        style="text-align: center;width: 100%"
        :action="UploadUrl()"
        :showUploadList="false"
        @change="handleImageSuccess"
        :before-upload="beforeAvatarUploadImg">
        <!--        <i class="avatar-uploader-icon"></i>-->
        <a-button>
          上传
        </a-button>
      </a-upload>
      <!--        </a-form-model-item>-->
      <!--      </a-form-model>-->
    </a-modal>
    <a-modal
      title="揽收"
      v-model="collectGoodsShow"
      width="500px"
      align="center"
      @ok="submitCollectTime"
    >
      <a-form-model :data="collectGoodsForm">
        <a-form-model-item label="选择揽时间">
          <a-date-picker
            v-model="collectGoodsForm.collectTime" show-time placeholder="选择日期时间"
            format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss"></a-date-picker>
        </a-form-model-item>
      </a-form-model>
      <!--      <a-button @click="submitCollectTime">确定</a-button>-->
    </a-modal>
    <a-modal
      title="导出文件"
      v-model="exportVisible"
      :before-close="exportHandleClose"
      width="30%"
      @ok="downloadRecentExcelOk"
      :maskClosable="false"
      :destroyOnClose="false">
      <a-form-model label-width="100px" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="日期" :colon="false">
          <a-range-picker
            style="width: 100%"
            :show-time="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'),moment('23:59:59', 'HH:mm:ss')] }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['Start Time', 'End Time']"
            v-model="exportForm.data.timeScope"
          />
        </a-form-model-item>
        <a-form-model-item label="运输单号" :colon="false">

          <a-input v-model="exportForm.sendOrder" auto-complete="off" placeholder="请输入运输单号" clearable
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="IFS单号" :colon="false">
          <a-input v-model="exportForm.ifs" auto-complete="off" placeholder="请输入IFS单号" clearable
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="预警状态" prop="" :colon="false">
          <a-select v-model="exportForm.isWarn" placeholder="请输入预警状态" clearable>
            <a-select-option
              v-for="item in warnList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="订单状态" prop="" :colon="false">
          <a-select v-model="exportForm.orderStatus" placeholder="请输入订单状态" clearable>
            <a-select-option
              v-for="item in orderStatusList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="运输方式" :colon="false">
          <a-select v-model="exportForm.express" filterable :collapse-tags="true"
                    placeholder="请输入运输方式" :clearable="true">
            <a-select-option
              v-for="item in expressTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="发货地点" :colon="false">
          <a-select v-model="exportForm.sendCity" filterable multiple :collapse-tags="true"
                    placeholder="请输入发货地" :clearable="true">
            <a-select-option
              v-for="item in cities"
              :key="item.city"
              :label="item.city"
              :value="item.city">
              {{ item.city }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="客户名称" :colon="false">
          <a-input v-model="exportForm.customer" auto-complete="off" placeholder="请输入客户名称" clearable
          ></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment';
import {
  changeCollectTime, getCity, getExpress, getOrderList, getRecentOrder
} from '../../../api/order';
import OrderSalesman from './OrderSalesman.vue';
import GaodeMap from '../../../components/GaodeMap.vue';
import TimeLine from '../../../components/TimeLine.vue';
import BizOrderEdit from './BizOrderEdit.vue';
import DateTimeFormatter from '@/components/DateTimeFormatter.vue';
import {delSalesman} from "../../../api/salesman";
import {getTime} from "../../../utils/dateUtil";

/**
 * 初始化数据
 */
async function getList() {
  this.table.loading = true;
  // if (this.customer !== ''){
  // }
  this.gaoDeShow = false;
  if (this.timeline) {
    this.timeLineShow = true;
  } else {
    this.timeLineShow = false;
  }
  this.table.data = [];
  const timeScope = this.searchForm.data.timeScope && this.searchForm.data.timeScope.length === 2
    ? this.searchForm.data.timeScope : [null, null];

  const customer = this.customer.toString();
  const sendOrder = this.sendOrder.toString();
  const { order } = this.table.sort;
  const result = await getOrderList({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: order === 'ascend' ? 'ASC' : 'DESC',
    ifs: this.ifs,
    orderNo: sendOrder,
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    city: this.sendCity,
    isWarn: this.isWarn,
    orderStatus: this.orderStatus,
    customer: customer,
    express: this.express,
  });
  if (result.code === 1200) {
    const data = result.data.orders;
    this.$set(this.table, 'data', data.map(x => ({
      ...x,
      orderStatusStr: x.orderStatus === 'CLOSED' ? '签收'
        : x.orderStatus === 'SEND' ? '在途'
          : x.orderStatus === 'DELIVERY' ? '出库'
            : x.orderStatus === 'COLLECT' ? '揽收'
              : x.orderStatus === 'SUSPECTED_SIGN' ? '到达'
                : x.orderStatus === 'PARTIAL_CLOSED' ? '部分签收' : '新建',
      // deliveryAtStr: x.deliveryAt.substring(0, 10),
      agingStr: getAging(x),
    })))
    this.table.pagination.total = result.data.totalCount;
  }
  this.timeline = '';
  this.table.loading = false;
}

function showTrace() {
  this.timeline = 'show';
  // this.getList();
}

// eslint-disable-next-line consistent-return
function getAging(x) {
  let date = null;
  if (x.deliveryAt !== null) {
    date = x.deliveryAt;
  } else {
    date = x.createAt;
  }
  if (x.orderStatus === 'CLOSED') {
    const start = new Date(date);
    const end = new Date(x.receiveAt);
    const diff = 1000 * 3600;
    // eslint-disable-next-line radix
    return parseInt((end.getTime() - start.getTime()) / parseInt(diff));
  }
  if (x.aging) {
    // eslint-disable-next-line radix
    return parseInt(x.aging) * 24;
  }
}

function editBizOrder(bizOrderId) {
  this.form.data.id = bizOrderId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getList();
}

function orderSalesman(id) {
  this.visible = true;
  this.form.data.orderId = id;
}

function dCreateTime(value) {
  const date = new Date(parseInt(value));
  // const Y = `${date.getFullYear()}-`;
  // const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
  // const Y = `${date.getFullYear()}-`;
  // const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
  const Y = `${ date.getFullYear() }-`;
  const M = `${ date.getMonth() + 1 < 10 ? `0${ date.getMonth() + 1 }` : date.getMonth() + 1 }-`;
  const D = date.getDate();
  return Y + M + D;
}

/**
 * 显示条目数
 * @param val
 */
function handleSizeChange(val) {
  this.table.pagination.pageSize = val;
  this.getList();
}

/**
 * 当前页
 * @param val
 */
function handleCurrentChange(val) {
  this.table.pagination.current = val;
  this.getList();
}

/**
 * 列表排列的序号
 * @param index
 * @returns {*}
 */
function table_index(index) {
  return (this.listQuery.page - 1) * this.listQuery.size + index + 1;
}

async function onFormSaveEdit() {
  this.form.visible = false;
  await this.$refs.orderEdit.save();
  // this.getList();
  this.form.data = {};
}


function onFormCancelEdit() {
  this.form.visible = false;
  this.getList();
  this.form.data = {};
}

function onFormSave() {
  this.visible = false;
  this.getList();
  this.form.data = {};
}


function onFormCancel() {
  this.visible = false;
  this.getList();
  this.form.data = {};
}

async function receipt(row) {
  this.form.data.img = row.img;
  this.form.data.orderNo = row.orderNo;
  console.log(this.form.data.img)
  this.imageVisible = true;
}

function getUrlBase64(url) {
  return new Promise((resolve) => {
    let canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // 允许跨域
    image.src = url;
    image.onload = function () {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0, image.width, image.height);
      const dataURL = canvas.toDataURL('image/png');
      canvas = null;
      resolve(dataURL);
    };
  });
}

function downs() {
  // window.location.href = '/api/'+ this.form.data.img;
  window.open(`api${ this.form.data.img }`);
  // window.open(`api${ this.form.data.img }`);
  // window.open(`api${ this.form.data.img }`);
  // this.getUrlBase64(`api${this.form.data.img}`).then((base64) => {
  //     const link = document.createElement('a');
  //     link.href = base64;
  //     link.download = this.form.data.orderNo;
  //     link.click();
  // });
  this.imageVisible = false;
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

function handledbClick(row) {
  this.gaoDeShow = false;
  setTimeout(() => {
    if (row.transportType === 'GPS') {
      this.form.order = row;
      this.timeLineShow = false;
      this.gaoDeShow = true;
    } else {
      this.gaoDeShow = false;
      this.timeLineShow = true;
      this.form.data.orderId = row.orderNo;
      this.form.data.expressCode = row.expressCode;
      this.form.data.receiveAddress = row.receiveAddress;
      this.form.data.wmsNo = row.wmsNo;
      this.form.data.ifsNo = row.ifsNo;
    }
  }, 500);
}

/**
 * 文件上传之前的回调函数
 */
// eslint-disable-next-line consistent-return
function beforeAvatarUpload(file) {
//        判断上传文件的后缀 是否为 xls 或 xlsx 格式
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ',
      content: '',
      okType: 'warning',
      onOk() {
        that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    return false;
  }
}

function handleSuccess(res) {
  if (this.uploadTrue) {
    if (res.file.response && res.file.response.code === 1200) {
      this.$message.success('上传成功');
      this.getList();
    }
  } else {
    this.uploadTrue = !this.uploadTrue
  }

}

async function downloadExcel() {
  let that = this;
  this.$confirm({
    title: '是否下载导入运费和计费重量模板.xlsx？?',
    content: '',
    okType: 'warning',
    onOk() {
      window.location.href = '/api/signForImg/导入运费和计费重量模板.xlsx';
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });
}

function downloadRecentExcel() {
  this.exportVisible = true;
}

async function downloadRecentExcelOk() {
  this.$message.success('处理成功等待下载');
  this.exportVisible = false;
  const timeScope = this.exportForm.data.timeScope && this.exportForm.data.timeScope.length === 2
    ? this.exportForm.data.timeScope : [null, null];
  const customer = this.exportForm.customer.toString();
  const sendOrder = this.exportForm.sendOrder.toString();
  const result = await getOrderList({
    page: 1,
    size: 9999999,
    direction: 'DESC',
    sort: 'createAt',
    ifs: this.exportForm.ifs,
    orderNo: sendOrder,
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    city: this.exportForm.sendCity,
    isWarn: this.exportForm.isWarn,
    orderStatus: this.exportForm.orderStatus,
    customer: customer,
    express: this.exportForm.express,
  });
  // this.recentOrder = result.orders;
  let list = result.data.orders;
  list = list.map(x => ({
    ...x,
    transportTypeStr: x.transportType === 'GPS' ? "GPS" : x.transportType === 'THIRDPART' ? '快递鸟' : '',
    orderStatusStr: x.orderStatus === 'CLOSED' ? '签收'
      : x.orderStatus === 'SEND' ? '在途'
        : x.orderStatus === 'DELIVERY' ? '出库'
          : x.orderStatus === 'COLLECT' ? '揽收'
            : x.orderStatus === 'SUSPECTED_SIGN' ? '到达'
              : x.orderStatus === 'PARTIAL_CLOSED' ? '部分签收' : '新建',
    // deliveryAtStr: x.deliveryAt.substring(0, 10),
    agingStr: getAging(x),
  }));
  require.ensure([], () => {
    const { export_json_to_excel } = require('../../../utils/Export2Excel');
    const tHeader = ['运输单号', '创建时间', '发货时间', 'IFS No', 'WMS No', 'GPS No', '运输方式', '签收日期', '发货城市', '收货城市', '收货地址', '订单状态', '运费', '计费重量', '时效', '制单人'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['orderNo', 'createAt', 'deliveryAt', 'ifsNo', 'wmsNo', 'gpsNo', 'expressCode', 'receiveAt', 'sendCity', 'receiveCity', 'receiveAddress', 'orderStatusStr', 'freight', 'chargeableWeight', 'aging', 'documentMaker'];
    // 上面的index、nickName、name是tableData里对象的属性
    const data = this.formatJson(filterVal, list.reverse());
    let start = timeScope[0] ? moment(timeScope[0])
      .format('YYYY年MM月DD日HH时mm分ss秒') : null;
    let end = timeScope[1] ? moment(timeScope[1])
      .format('YYYY年MM月DD日HH时mm分ss秒') : null;
    let title = start + " 至 " + end + " 订单"
    export_json_to_excel(tHeader, data, title);
  });
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

function cellStyle({ row }) {
  if (row.orderNo === '' || row.orderNo === null || row.receiveCity === '' || row.receiveCity === null
    || (row.gpsNo === '' && row.expressCode === '') || (row.gpsNo === null && row.expressCode === '')
    || (row.gpsNo === '' && row.expressCode === null) || (row.gpsNo === null && row.expressCode === null)) {
    return 'row-color';
  }
}

function search() {
  this.listQuery.page = 1;
  this.getList();
}

/**
 * 文件上传之前的回调函数
 */
function beforeAvatarUploadImg(file) {
  const flag = this.compareImage(file);
  if (!flag) {
    let that = this;
    this.$confirm({
      title: '上传文件必须为图片格式 ',
      content: '',
      okType: 'warning',
      onOk() {
      },
      //   this.onCancel()
      onCancel() {
      },
      class:
        'test',
    });
  }
  return flag;
}

/**
 *  判断上传文件是否为图片
 * @param file
 * SUN
 */
function compareImage(file) {
  let flag = true;
  const fileName = this.getLast3Str(file);
  if (fileName !== 'svg' && fileName !== 'png' && fileName !== 'jpg' && fileName !== 'SVG' && fileName !== 'PNG' && fileName !== 'JPG') {
    flag = false;
  }
  return flag;
}

/**
 * 上传成功
 */
function handleImageSuccess(res, info) {
  this.dialogVisible = false;
  if (res.file.response.code === 1200) {
    this.$message.success('签收成功');
    this.dialogVisible = false;
    this.getList();
  }
}

function handleClose() {
  this.dialogVisible = false;
  this.getList();
}

function exportHandleClose() {
  this.dialogVisible = false;
}


/**
 * 获取上传文件的后缀名字符串 （后缀长度均为3）
 * @param file
 * @returns {string} SUN
 */
function getLast3Str(file) {
  const fileName = file.name;
  const index = fileName.lastIndexOf('.') + 1;
  return fileName.substring(index);
}

function sign(id) {
  this.fileData.id = id;
  this.dialogVisible = true;
}

/**
 * @return {string}
 */
function UploadUrl() {
  return `api/update-order-status/${ this.fileData.id }`;
  // return `api/update-order-status/${this.fileData.id}`;
  // return `api/update-order-status/${this.fileData.id}`;
}

function collectGoods(row) {
  this.collectGoodsForm.id = row.id;
  this.collectGoodsForm.collectTime = row.collectTime
  this.collectGoodsShow = true;
}

async function submitCollectTime() {
  const time = this.collectGoodsForm.collectTime;
  // let collectTime = time.getFullYear() + "-" + Number.parseInt(time.getMonth()) + 1 + "-" + time.getDate() + " " + time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
  // this.collectGoodsForm.collectTime = collectTime;
  const res = await changeCollectTime(this.collectGoodsForm);
  if (res.code === 1200) {
    this.collectGoodsShow = false;
    this.collectGoodsForm = {
      id: '',
      collectTime: '',
    };
    this.$message.success('已揽收');
    this.getList();
  }
}

function downloadImage(imgsrc, name) { //下载图片地址和图片名
  let image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    let a = document.createElement("a"); // 生成一个a元素
    let event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgsrc;
  this.form.data.img = '';
  this.form.data.orderNo = '';
  this.imageVisible = false;
}

export default {
  components: {
    OrderSalesman,
    GaodeMap,
    TimeLine,
    BizOrderEdit,
    DateTimeFormatter,
  },
  methods: {
    getList,
    handleSizeChange,
    handleCurrentChange,
    table_index,
    orderSalesman,
    onFormSave,
    onFormSaveEdit,
    onFormCancel,
    onFormCancelEdit,
    receipt,
    getUrlBase64,
    downs,
    downloadImage,
    handledbClick,
    editBizOrder,
    closeForm,
    beforeAvatarUpload,
    handleSuccess,
    downloadExcel,
    dCreateTime,
    cellStyle,
    search,
    sign,
    beforeAvatarUploadImg,
    compareImage,
    handleImageSuccess,
    getLast3Str,
    handleClose,
    exportHandleClose,
    UploadUrl,
    getAging,
    showTrace,
    collectGoods,
    submitCollectTime,
    getExpress,
    handleTableChange,
    downloadRecentExcel,
    downloadRecentExcelOk,
    formatJson,
    moment
  },
  async created() {
    const _this = this;
    for (let i = 0; i < _this.colData.length; i++) {
      _this.colSelect.push(_this.colData[i].title);
      if (_this.colData[i].title == '运费' || _this.colData[i].title == '计费重量') { // 初始化不想展示的列可以放在这个条件里
        continue;
      }
      _this.colOptions.push(_this.colData[i].title);
    }
    const res = await getCity();
    if (res.code === 1200) {
      this.cities = res.data.sendCity;
    }
    // const orderNoRes = await getOrderNo();
    // if (orderNoRes.code === 1200) {
    //   this.orders = orderNoRes.data.orderNo
    // }
    // const expressRes = await getExpress();
    // if (expressRes.code === 1200) {
    //   this.expressTypes = expressRes.data.express
    // }
    // const customerRes = await getCustomer();
    // if (customerRes.code === 1200) {
    //   this.customers = customerRes.data.customer
    // }
  },
  data() {
    return {
      isWarn: '',
      timeline: '',
      fileData: {
        id: '',
      },
      warnList: [
        { code: 0, name: '正常' },
        { code: 1, name: '预警' },
      ],
      orderStatus: '',
      orderStatusList: [
        { code: "CREATE", name: '新建' },
        { code: "DELIVERY", name: '出库' },
        { code: "COLLECT", name: '揽收' },
        { code: "SEND", name: '在途' },
        { code: "CLOSED", name: '签收' },
        { code: "SUSPECTED_SIGN", name: '到达' },
      ],
      dialogVisible: false,
      exportVisible: false,
      dialogTitle: '上传签收凭证',
      sendCity: '',
      cities: [],
      sendOrder: '',
      orders: [],
      express: '',
      expressTypes: [{
        value: 'GPS',
        label: '汽运',
      }, {
        value: 'THIRDPART',
        label: '快递',
      },{
          value: 'EMPTY',
          label: '空',
      },{
          value: '其他',
          label: '其他',
      }],
      customer: '',
      customers: [],
      visible: false,
      imageVisible: false,
      searchForm: {
        data: {
          timeScope: [],
        },
      },
      exportForm: {
        data: {
          timeScope: []
        },
        sendOrder: '',
        ifs: '',
        isWarn: '',
        orderStatus: '',
        express: '',
        sendCity: '',
        customer: ''
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 3,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['3', '10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
        sort: {
          prop: 'createAt',
          order: 'descend',
        },
      },
      searchData: [],
      uploadTrue: false,
      listQuery: { totalAmount: 0, page: 1, size: 3 },
      time: [],
      order: '',
      ifs: '',
      transpotType: '',
      orderNo: '',
      gaoDeShow: false,
      timeLineShow: false,
      form: {
        order: {},
        data: {
          id: null,
          orderId: '',
          expressCode: '',
          receiveAddress: '',
          img: '',
        },
        visible: false,
      },
      colData: [{ title: 'No.', istrue: true },
        { title: '运输单号', istrue: true },
        { title: '发货时间', istrue: true },
        { title: 'IFS NO', istrue: true },
        { title: 'WMS NO', istrue: true },
        { title: 'GPS NO', istrue: true },
        { title: '运输方式', istrue: true },
        { title: '签收日期', istrue: true },
        { title: '发货城市', istrue: true },
        { title: '收货城市', istrue: true },
        { title: '客户名称', istrue: true },
        { title: '订单状态', istrue: true },
        { title: '运费', istrue: true },
        { title: '计费重量', istrue: true },
        { title: '时效', istrue: true },
        { title: '制单人', istrue: true },
        { title: '操作', istrue: true },
      ],
      colOptions: [],
      colSelect: [],
      collectGoodsShow: false,
      collectGoodsForm: {
        id: '',
        collectTime: '',
      },
      recentOrder: []
    };
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
  .main-body .el-table .row-color {
    background: rgba(255, 0, 0, 0.3) !important;
  }

  .main-body .el-table .row-color:hover {
    background: rgba(255, 0, 0, 0.3) !important;
  }

  .main-body .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .el-checkbox {
    padding-top: 5px;
  }

  .el-checkbox__label {
    font-size: 12px;
  }

  .el-checkbox:last-of-type {
    margin-right: 10px;
  }

  .el-icon-setting:hover {
    cursor: pointer;
  }
</style>

<style>

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #8c939d;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
